var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcademyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3 13.5C3 7.84314 3 5.01472 4.75735 3.25735C6.51472 1.5 9.34314 1.5 15 1.5H21C26.6568 1.5 29.4853 1.5 31.2426 3.25735C33 5.01472 33 7.84314 33 13.5V19.5C33 25.1568 33 27.9853 31.2426 29.7426C29.4853 31.5 26.6568 31.5 21 31.5H15C9.34314 31.5 6.51472 31.5 4.75735 29.7426C3 27.9853 3 25.1568 3 19.5V13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5355 3.96447L30.5355 3.96444C29.8736 3.30256 28.9734 2.91551 27.4504 2.71075C25.8986 2.50212 23.8567 2.5 21 2.5H15C12.1433 2.5 10.1014 2.50212 8.54962 2.71075C7.02663 2.91551 6.12638 3.30255 5.46446 3.96446C5.46446 3.96446 5.46446 3.96446 5.46446 3.96446M5.46446 3.96446C4.80255 4.62638 4.41551 5.52663 4.21075 7.04962C4.00212 8.60138 4 10.6433 4 13.5V19.5C4 22.3567 4.00212 24.3986 4.21075 25.9504C4.41551 27.4734 4.80256 28.3736 5.46444 29.0355L5.46447 29.0355C6.12639 29.6974 7.02663 30.0845 8.54962 30.2892C10.1014 30.4979 12.1433 30.5 15 30.5H21C23.8567 30.5 25.8986 30.4979 27.4504 30.2892C28.9734 30.0845 29.8736 29.6974 30.5355 29.0355L30.5355 29.0355C31.1974 28.3736 31.5845 27.4734 31.7892 25.9504C31.9979 24.3986 32 22.3567 32 19.5V13.5C32 10.6433 31.9979 8.60138 31.7892 7.04962C31.5845 5.52663 31.1974 4.62639 30.5355 3.96447M4.75735 3.25735C3 5.01472 3 7.84314 3 13.5V19.5C3 25.1568 3 27.9853 4.75735 29.7426C6.51472 31.5 9.34314 31.5 15 31.5H21C26.6568 31.5 29.4853 31.5 31.2426 29.7426C33 27.9853 33 25.1568 33 19.5V13.5C33 7.84314 33 5.01472 31.2426 3.25735C29.4853 1.5 26.6568 1.5 21 1.5H15C9.34314 1.5 6.51472 1.5 4.75735 3.25735Z",
    fill: "#8A91A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 10.75H22.5V11.875H23.25V10.75Z",
    fill: "#394D8B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 8.125H22.5V10H23.25V8.125Z",
    fill: "#394D8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 11.125C23.2892 11.125 23.625 10.7892 23.625 10.375C23.625 9.96079 23.2892 9.625 22.875 9.625C22.4608 9.625 22.125 9.96079 22.125 10.375C22.125 10.7892 22.4608 11.125 22.875 11.125Z",
    fill: "#AEB7D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.82617V9.62492C15 10.4537 15.6712 11.1249 16.5 11.1249H19.5C20.3288 11.1249 21 10.4537 21 9.62492V8.82617L18 9.62492L15 8.82617Z",
    fill: "#9DA8C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.625L12.375 8.125L18 5.125L23.625 8.125L18 9.625Z",
    fill: "#394D8B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 26.125V16.375L18 11.875L22.5 16.375V26.125",
    fill: "#394D8B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C19.0355 19 19.875 18.1605 19.875 17.125C19.875 16.0895 19.0355 15.25 18 15.25C16.9645 15.25 16.125 16.0895 16.125 17.125C16.125 18.1605 16.9645 19 18 19Z",
    fill: "#AEB7D0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.625H9.375V26.125H13.5V18.625Z",
    fill: "#A2ADCD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.625 18.625H22.5V26.125H26.625V18.625Z",
    fill: "#A2ADCD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26.125V23.125H19.5V26.125",
    fill: "#AEB7D0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.375H27.375V18.625H22.5",
    fill: "#7983A3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.625H8.625V16.375H13.5",
    fill: "#7983A3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 26.125H6.75V26.875H29.25V26.125Z",
    fill: "#CACFDF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 23.125H17.625V26.125H18.375V23.125Z",
    fill: "#AEB7D0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C16.965 19 16.125 18.16 16.125 17.125C16.125 16.09 16.965 15.25 18 15.25",
    fill: "#AEB7D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademyIcon);
export default __webpack_public_path__ + "static/media/AcademyIcon.85131dcba00d145bf5871fd1c485f398.svg";
export { ForwardRef as ReactComponent };